import { observable } from 'mobx';
const tutorial = {
  1: {
    show: true,
    index: 0,
    details: [
      {
        hightlightIds: [
          "play-source",
          "play-tuned"
        ],
        content: `Welcome! The object of this game
    is to make the notes on the right sound in tune with the left. Start by listening to each side via the play buttons. Notice that the right note is out of tune.`
      },
      {
        hightlightIds: [
          "drag-circle"
        ],
        content: `Use the slider to move the right note until it sounds in tune with the left note.`
      },
      {
        hightlightIds: [
          "submit-button"
        ],
        content: `Press submit to check your answer. A wrong answer will cost you a life! Get enough right and move on to the next level!`
      },
    ]
  },
  2: {
    show: true,
    index: 0,
    details: [
      {
        hightlightIds: [
          // "tuned-circle",
        ],
        content: `Level 2! Great! Now there are multiple notes in interval harmony. Only one note is out of tune. Tap a note to select and isolate a note, and use the slider to tune the isolated note. You can use the same play buttons to hear them together.`
      },
    ]
  },
  3: {
    show: true,
    index: 0,
    details: [
      {
        hightlightIds: [
        ],
        content: `Level 3! Wow! Try some triads! Again, only one note is out of tune.`
      },
    ]
  },
  4: {
    show: true,
    index: 0,
    details: [
      {
        hightlightIds: [
        ],
        content: `Level 4! Outstanding! Be careful, now you must use your ears! Only one note is out of tune, but you must not touch the notes that are not! Good luck!`
      },
    ]
  }
};
const theDefault = {};
class TutorialStore {
  @observable tutorial = tutorial;
  @observable state = theDefault;
  constructor() {
    const val = JSON.parse(localStorage.getItem("tune-tutorial"));
    if (!val) {
      this.state = theDefault;
    }
    else {
      const storedKeys = Object.keys(val);
      storedKeys.forEach( key => {
        this.tutorial[parseInt(key, 10)].show = !val[key];
      });
      this.state = val;
    }
  }
  setShowHelp(key, val) {
    // reset the index to zero for this key if going to true
    if (val) {
      this.tutorial[key].index = 0;
    }
    this.tutorial[key].show = val;
  }
  getObjectForLevel(key) {
    const level = this.tutorial[key];
    return level;
  }
  nextPressed(key) {
    // if its bigger than the length then set disk and turn show off?
    const level = this.tutorial[key];
    //if on the last object
    if (level.index >= level.details.length - 1) {
      level.show = false;
      this.state[key] = true;
      localStorage.setItem("tune-tutorial", JSON.stringify(this.state));
    }
    else {
      level.index++;
    }
  }
}
export const observableTutorialStore = new TutorialStore();



// WEBPACK FOOTER //
// ./src/stores/tutorial-store.js